import React from 'react';
import { cn } from '../../utils';
import type { QCallFloatingConfig } from '../../types';
import { DefaultStyleContainer } from '../ui-styles/default-style';
import { MinimalStyleContainer } from '../ui-styles/minimal-style';

export interface FloatingWidgetProps {
  /** Widget configuration */
  config: QCallFloatingConfig;
  /** Additional class names */
  className?: string;
}

/**
 * Floating widget component - main container
 * Renders different UI styles based on config.uiStyle
 */
export function FloatingWidget({ config, className }: FloatingWidgetProps) {
  const { uiStyle = 'default' } = config;

  // Render style-specific container
  switch (uiStyle) {
    case 'minimal':
      return <MinimalStyleContainer config={config} className={className} />;
    case 'default':
    default:
      return <DefaultStyleContainer config={config} className={className} />;
  }
}
